import React, { useState } from "react";
import BuscarGuia from "../../../components/BuscarGuia";
import ImageViewer from "../../../components/imageViever/imageViewer";
import { CircularProgress } from "@material-ui/core";

export default function EscaneoSimple(props) {
  const [idGuia, setIdGuia] = useState(null);

  const onGuiaChange = (guia) => {
    setIdGuia(guia.id);
  };

  return (
    <div>
      <BuscarGuia onSelect={onGuiaChange} estado={[6]} condiciones={false} textoBoton={'Buscar'} />
      <div>
        {idGuia &&
          (props.reloadComponent ? (
            <CircularProgress />
          ) : (
            <ImageViewer
              id_guia={idGuia}
              index={1}
              navegacion={false}
              scanner
              socketId={props.socketId}
            />
          ))}
      </div>
    </div>
  );
}
